export default __webpack_public_path__ + "static/media/ic_menu_onoffboard_manager.ddd6047f.svg";